import {
  CsvFieldByHeader,
  downloadCsv,
  recordsFromCsv,
} from "../../components/massFlow/csv";
import { CdnPayload, emptyCdn } from "../types";

export const CSV_HEADERS = ["Nome", "ASN", "Tipo", "Bloco"];

const CSV_EXAMPLES = [
  ["CDN exemplo 01", "13335", "cache", "192.168.0.0/24"],
  ["CDN exemplo 02", "32934", "peering", "10.0.0.0/22"],
];

const FIELD_BY_HEADER: CsvFieldByHeader = {
  nome: "as_name",
  name: "as_name",
  asname: "as_name",
  nomecdn: "as_name",
  nomedocdn: "as_name",
  asn: "as_num",
  asnum: "as_num",
  numeroasn: "as_num",
  numerodoasn: "as_num",
  as: "as_num",
  tipo: "tipo",
  type: "tipo",
  bloco: "bloco",
  blocos: "bloco",
  prefixo: "bloco",
  cidr: "bloco",
};

export function cdnsFromCsv(text: string): CdnPayload[] {
  return recordsFromCsv(text, {
    fieldByHeader: FIELD_BY_HEADER,
    emptyValues: emptyCdn,
    expectedHeaders: CSV_HEADERS,
  });
}

export function downloadCsvTemplate() {
  downloadCsv("MW Soluções - Template CDNs.csv", [
    CSV_HEADERS,
    ...CSV_EXAMPLES,
  ]);
}
